import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from "@angular/core";
import { statusesStyleDictionary, statusGroupesStyleDictionary } from "./simulationStatusStyle";

@Directive({
    selector: '[appSimulationStyle]'
})
export class SimulationStyleDirective implements OnChanges {
    @Input() status: number = 0;
    @Input() typeStyle: string = "";
    @Input() isSelected: boolean = false;
    
    constructor(private elementRef: ElementRef) {}

    ngOnChanges(changes: SimpleChanges): void {
        const color = statusesStyleDictionary.get(this.status)||'grey';
        const colorGroup = statusGroupesStyleDictionary.get(this.status)||'grey';
        
        if(this.typeStyle == "") {
            this.elementRef.nativeElement.style.backgroundColor = color;
        }
        else if(this.typeStyle == "A") {
            this.elementRef.nativeElement.style.border = `2px solid ${color}`;
            if(this.isSelected) {
                this.elementRef.nativeElement.style.backgroundColor = color;
            }
            else { this.elementRef.nativeElement.style.backgroundColor = 'white' }
        }
        else if(this.typeStyle == "B") {
            this.elementRef.nativeElement.style.border = `2px solid ${colorGroup}`;
            if(this.isSelected) {
                this.elementRef.nativeElement.style.backgroundColor = colorGroup;
            }
            else { this.elementRef.nativeElement.style.backgroundColor = 'white' }
        }
    }
}